import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Image, Mail, Send, ClipboardList, LogOut, ArrowLeft } from "lucide-react";

const NAV_ITEMS = [
  { to: "/admin/galeria", label: "Galeria", icon: Image },
  { to: "/admin/orcamentos", label: "Orçamentos", icon: ClipboardList },
  { to: "/admin/contatos", label: "Contatos", icon: Mail },
  { to: "/admin/newsletter", label: "Newsletter", icon: Send },
];

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-sm transition-colors ${
    isActive
      ? "bg-[var(--mn-gold)] text-white"
      : "text-[var(--mn-dark)] hover:bg-[var(--mn-cream)] hover:text-[var(--mn-black)]"
  }`;

export default function AdminSidebar({ onLogout }) {
  return (
    <aside
      className="w-full lg:w-64 shrink-0 bg-white border-b lg:border-b-0 lg:border-r border-[var(--mn-line)] lg:min-h-screen"
      data-testid="admin-sidebar"
    >
      <div className="px-5 py-6 border-b border-[var(--mn-line)]">
        <div className="text-[0.7rem] uppercase tracking-[0.28em] text-[var(--mn-gold)] font-semibold">
          M NAIEF
        </div>
        <h1 className="font-serif-display font-extrabold text-xl text-[var(--mn-black)] leading-tight mt-1">
          Painel Admin
        </h1>
      </div>

      <nav className="p-3 flex flex-col gap-1" aria-label="Menu do admin">
        {NAV_ITEMS.map((item) => (
          <NavLink key={item.to} to={item.to} className={linkClass} data-testid={`admin-nav-${item.label.toLowerCase()}`}>
            <item.icon size={17} />
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-[var(--mn-line)] mt-2 flex flex-col gap-1">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-[var(--mn-dark)] hover:text-[var(--mn-gold)] rounded-sm transition-colors"
        >
          <ArrowLeft size={17} /> Voltar ao site
        </Link>
        <button
          type="button"
          onClick={onLogout}
          className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-[var(--mn-dark)] hover:text-red-600 rounded-sm transition-colors text-left"
          data-testid="admin-logout"
        >
          <LogOut size={17} /> Sair
        </button>
      </div>
    </aside>
  );
}
